import React from 'react'

export default React.createContext({
  document: {},
  updateDocument: (e) => {},
})
